import { KEY_CODE } from "../constants";

export default function isEnterorSpaceKeyPressed(event) {
    if((event && event.keyCode && (event.keyCode === KEY_CODE.ENTER_KEY || event.keyCode === KEY_CODE.SPACE_KEY)) || (!event)){
        return true;
    }
    return false;
  }